export default __webpack_public_path__ + "static/media/maze_game.6a2901c2.png";